module.exports = __webpack_public_path__ + "img/rio.230a9d02.png";